export { default } from './QrHeaderView';



// WEBPACK FOOTER //
// ./src/components/views/QrHeaderView/index.js